import { render, staticRenderFns } from "./ToothbrushCard.vue?vue&type=template&id=69a9c9dc&"
import script from "./ToothbrushCard.vue?vue&type=script&lang=js&"
export * from "./ToothbrushCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports